export default __webpack_public_path__ + "static/media/SFProText-Regular.3b44678c.woff";